import { render, staticRenderFns } from "./ResizableDataTableGlobalOffers.vue?vue&type=template&id=6bde42f2&scoped=true&lang=html&"
import script from "./ResizableDataTableGlobalOffers.vue?vue&type=script&lang=js&"
export * from "./ResizableDataTableGlobalOffers.vue?vue&type=script&lang=js&"
import style0 from "./ResizableDataTableGlobalOffers.vue?vue&type=style&index=0&id=6bde42f2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bde42f2",
  null
  
)

export default component.exports